import {
  Box,
  Flex,
  Select,
  Stack,
} from "@chakra-ui/react";
import { useEffect, useState } from "react";
import { Target } from "types/Target";

type TargetFilterProps = {
  target: Target;
  subTargetFilter: boolean;
  labelFilter: boolean;
  placeholderSubTarget: string;
  placeholderLabel: string;
  timePeriods : any;
  handlerOnChangeSubTarget: (params: any) => any;
  handlerOnChangeLabel: (params: any) => any;
  tabIndex : number;
  selectedSubTarget: string;
  selectedLabel: string;
};

export default function TargetFilter({
  target,
  subTargetFilter,
  placeholderSubTarget,
  placeholderLabel,
  timePeriods,
  labelFilter,
  handlerOnChangeSubTarget,
  handlerOnChangeLabel,
  tabIndex,
  selectedSubTarget,
  selectedLabel
}: TargetFilterProps) {

  useEffect(() => {
    handlerOnChangeLabel(null);
    handlerOnChangeSubTarget(null);
  }, [tabIndex]);

  return (
    <>
      {subTargetFilter && (
        <>
          <Flex>
            <Box w={labelFilter ? "70%" : "100%" }>
              <Select
                aria-label="Seleziona un sotto-obiettivo"
                placeholder={placeholderSubTarget}
                onChange={handlerOnChangeSubTarget}
                defaultValue={0}
                value={selectedSubTarget}
              >
                {target?.subtargets?.map((subTarget, index) => {
                  return (
                    <option key={index} value={subTarget?._id}>
                      Sotto-obiettivo {subTarget?.index}
                    </option>
                  );
                })}
              </Select>
            </Box>
            {
              labelFilter &&
            
            <Box w="30%">
              <Select
                aria-label="Seleziona un periodo"
                placeholder={placeholderLabel}
                onChange={handlerOnChangeLabel}
                defaultValue={0}
                value={selectedLabel}
              >
                {
                  timePeriods.map((timePeriod: any, index: number) => {
                    return (
                      <option key={index} value={timePeriod}>
                        {timePeriod}
                      </option>
                    );
                  })
                }
              </Select>
            </Box>
            }
          </Flex>
        </>
      )}
    </>);
}
